export enum SurveyAnswer {
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  MOTORI_DI_RICERCA = 'MOTORI_DI_RICERCA',
  MANIFESTI_BROCHURE = 'MANIFESTI_BROCHURE',
  FIDELITY = 'FIDELITY',
  EVENTO_ONAV = 'EVENTO_ONAV',
  MINI_CORSO_ASSAGGIATORE = 'MINI_CORSO_ASSAGGIATORE',
  PASSAPAROLA = 'PASSAPAROLA',
  EX_SOCIO = 'EX_SOCIO',
  ALTRO = 'ALTRO',
}

export const SURVEY_ANSWER_LABELS: Record<SurveyAnswer, string> = {
  [SurveyAnswer.INSTAGRAM]: 'Instagram',
  [SurveyAnswer.FACEBOOK]: 'Facebook',
  [SurveyAnswer.MOTORI_DI_RICERCA]: 'Motori di ricerca web',
  [SurveyAnswer.MANIFESTI_BROCHURE]: 'Manifesti/brochure',
  [SurveyAnswer.FIDELITY]: 'Fidelity',
  [SurveyAnswer.EVENTO_ONAV]: 'Evento Onav',
  [SurveyAnswer.MINI_CORSO_ASSAGGIATORE]: 'Mini-corso assaggiatore',
  [SurveyAnswer.PASSAPAROLA]: 'Passaparola',
  [SurveyAnswer.EX_SOCIO]: 'Ex socio',
  [SurveyAnswer.ALTRO]: 'Altro',
};

export const SURVEY_ANSWER_OPTIONS = Object.values(SurveyAnswer).map(
  (answer) => ({
    id: answer,
    attributes: { name: SURVEY_ANSWER_LABELS[answer] },
  })
);

export interface SurveyAnswerAttributes {
  questionKey: string;
  answer: SurveyAnswer;
  answerOther?: string | null;
  createdAt: string;
  profile?: {
    data: {
      id: number;
      attributes: {
        name: string;
        surname: string;
      };
    } | null;
  };
  course?: {
    data: {
      id: number;
      attributes: {
        title: string;
        section?: {
          data: {
            id: number;
            attributes: { name: string };
          } | null;
        };
      };
    } | null;
  };
}

export type SurveyAnswerResponse = {
  id: number;
  attributes: SurveyAnswerAttributes;
};
